import { ref } from 'vue'
import { AxiosInstance } from 'axios'
import {
  ItemsResponse,
  MessageRequestParam,
  ListResponse,
} from '/@src/models/api'
import {
  AdminCommentItem,
  AdminCommentListParams,
  CreateCommentParams,
  createComment,
  deleteAdminComment,
  getAdminCommentList,
  getComments,
  getSystemMessageList,
  getSystemMessageDetail,
  saveSystemMessageList,
} from '/@src/api/messageRepo'
import useApi from '/@src/composable/useApi'

export default function useGetComments() {
  const api = useApi()
  const response = ref<ItemsResponse<Comment>>()
  const adminCommentResponse = ref<ItemsResponse<AdminCommentItem>>()
  const getCommentsList = async (param: MessageRequestParam) => {
    if (param.limit === 0) {
      param.limit = 10
    }
    const ret = await getComments(api, param.limit, param.cursor)
    response.value = ret
  }
  const getAdminComments = async (params: AdminCommentListParams) => {
    const res = await getAdminCommentList(api, params)
    adminCommentResponse.value = res
    return res
  }
  const deleteAdminCommentById = async (cid: number) => {
    return deleteAdminComment(api, cid)
  }
  const replyComment = async (params: CreateCommentParams) => {
    return createComment(api, params)
  }
  const systemMessageResponse = ref<ListResponse<Comment>>()
  const getMessageList = async (params: MessageRequestParam) => {
    const res = await getSystemMessageList(api, params)
    systemMessageResponse.value = res
  }
  const systemMessageDetail = async (id: string) => {
    const res = await getSystemMessageDetail(api, id)
    return res
  }
  const saveSystemMessage = async (params: MessageRequestParam) => {
    const res = await saveSystemMessageList(api, params)
    return res
  }
  return {
    response,
    getCommentsList,
    getAdminComments,
    deleteAdminCommentById,
    replyComment,
    adminCommentResponse,
    getMessageList,
    systemMessageDetail,
    saveSystemMessage,
    systemMessageResponse,
  }
}
